import { View } from '@react-pdf/renderer'

import { SalesReportPdfStatistics } from '../../../../types/salesReportPdfStatistics'
import { SalesReportPdfStatisticsCardColumn } from './elements/SalesReportPdfStatisticsCardColumn'
import { pdfStyles } from './utils/pdfStyles'

interface SalesReportPdfStatisticsCardProps {
  statistics: SalesReportPdfStatistics
}

export const SalesReportPdfStatisticsCard = ({ statistics }: SalesReportPdfStatisticsCardProps) => {
  return (
    <View style={pdfStyles.card}>
      <SalesReportPdfStatisticsCardColumn label={statistics.totalSales.label} value={statistics.totalSales.value} />
      <SalesReportPdfStatisticsCardColumn label={statistics.totalPaid.label} value={statistics.totalPaid.value} />
      {statistics.totalUnpaid && (
        <SalesReportPdfStatisticsCardColumn label={statistics.totalUnpaid.label} value={statistics.totalUnpaid.value} />
      )}
      {statistics.totalItems && (
        <SalesReportPdfStatisticsCardColumn label={statistics.totalItems.label} value={statistics.totalItems.value} />
      )}
    </View>
  )
}
